/* eslint-disable react/no-array-index-key */
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  makeStyles,
  Typography
} from '@material-ui/core';
import React, { useState } from 'react';
import { ReactComponent as DownArrow } from 'assets/images/down.svg';
import { ReactComponent as CorrectOption } from 'assets/images/correct-option.svg';
import { ReactComponent as Empty } from 'assets/images/empty-state.svg';
import colors from 'utils/stylesheet/colors';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from '../styles.module.scss';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '99%'
  },
  header: {
    background: colors.grey,
    borderTopLeftRadius: '2px',
    borderTopRightRadius: '2px'
  },
  openHeader: {
    background: colors.dark_blue,
    border: `1px solid ${colors.border_blue}`,
    borderRadius: '2px',
    '&:hover': {
      boxShadow: '0px 4px 26px $dark_shade_blue'
    }
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '85%',
    flexShrink: 0
  },
  secHeading: {
    fontSize: '0.75rem',
    color: colors.lilac,
    fontWeight: 'normal',
    fontStyle: 'normal',
    lineHeight: '1rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '&$expanded': {
      fontWeight: 600
    }
  }
}));

const QuestionResult = ({ options, count, number, question }) => {
  const [expanded, setExpanded] = useState(-1);
  const classes = useStyles();

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const correctAnswer = options.findIndex((option) => option.correct);
  const noUserText = count === 0 ? 'Nobody answered the question' : 'Nobody chose this option';
  const getOptionAlphabet = (ind) => {
    switch (ind) {
      case 0:
        return 'A';
      case 1:
        return 'B';
      case 2:
        return 'C';
      case 3:
        return 'D';
      case 4:
        return 'E';
      default:
        return 'unknown';
    }
  };

  return (
    <div className={styles.questionResultWrapper}>
      <div className={styles.question}>
        <div className={styles.slNum}>{number}</div>
        <div className={styles.text}>{question}</div>
      </div>
      <div className={classes.root}>
        {options.map((option, ind) => (
          <div
            className={styles.accordianWrapper}
            key={ind}
            style={ind === options.length - 1 ? { marginBottom: 0 } : {}}
          >
            <div className={styles.alphabet}>{getOptionAlphabet(ind)}</div>
            <div className={classes.root}>
              <Accordion
                expanded={expanded === ind}
                onChange={handleChange(ind)}
                TransitionProps={{ unmountOnExit: true }}
                className={classNames(classes.header, { [classes.openHeader]: expanded === ind })}
              >
                <AccordionSummary expandIcon={<DownArrow />} className={classes.summary}>
                  <Typography variant='h5' className={classes.heading}>
                    <div className={styles.option}>
                      <div className={styles.percent}>
                        {Number.isInteger(option.percentage)
                          ? option?.percentage
                          : option?.percentage.toFixed(2)}
                        %
                      </div>
                      <div className={styles.optionText}>{option.value}</div>
                      {option.correct && <CorrectOption />}
                    </div>
                  </Typography>
                  <Typography className={classes.secHeading}>{option.pcount} people</Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.expanded}>
                  <div className={styles.userNames}>
                    {option.answeredUsers.length > 0 ? (
                      option.answeredUsers.map((user) => <span key={user.name}>{user.name}</span>)
                    ) : (
                      <div className={styles.noUsers}>
                        <Empty />
                        <div>{noUserText}</div>
                      </div>
                    )}
                  </div>
                </AccordionDetails>
              </Accordion>
            </div>
          </div>
        ))}
        <div className={styles.footer}>
          <p>
            <CorrectOption />
            <span>{getOptionAlphabet(correctAnswer)} - is the correct answer</span>
          </p>
          <div>{count === 0 ? 'No participation' : `${count} people answered`}</div>
        </div>
      </div>
    </div>
  );
};

QuestionResult.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      answeredUsers: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string.isRequired
        })
      ).isRequired,
      correct: PropTypes.bool.isRequired,
      pcount: PropTypes.number.isRequired,
      percentage: PropTypes.number.isRequired,
      value: PropTypes.string.isRequired
    })
  ).isRequired,
  count: PropTypes.number.isRequired,
  number: PropTypes.number.isRequired,
  question: PropTypes.string.isRequired
};

export default QuestionResult;
